import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  private refresh: Subject<boolean> = new BehaviorSubject<boolean>(false);

  get refresh$() {
    return this.refresh.asObservable();
  }

  browserUpdated(data: boolean) {
    this.refresh.next(data);
  }
}
